'use client';

import Error from 'next/error';

// eslint-disable-next-line react/prop-types
export default function GlobalError() {
  return (
    <html>
      <body>
        <Error />
      </body>
    </html>
  );
}
